import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

require('./bringoz-customized-table-columns-settings.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-customized-table-columns-settings',
  templateUrl: './bringoz-customized-table-columns-settings.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozCustomizedTableColumnsSettingsComponent implements OnInit, OnChanges {
  @Input() columns: any;
  @Input() title?: string;
  @Input() isOpen: boolean;
  @Input() columnsTranslationPrefix: string;
  @Output() onToggleIsOpen = new EventEmitter<boolean>();
  @Output() onColumnsChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {}

  toggleIsOpen(): void {
    this.onToggleIsOpen.emit(!this.isOpen);
  }

  columnsChanged(): void {
    this.onColumnsChange.emit(this.columns);
  }
}
